export const CONTEXTUAL_CONSENT_EXPERIMENT = 'ABACUS-562';
export const CONTEXTUAL_MEASUREMENT_OPT_OUT_COOKIE =
  'contextualMeasurement.optOut';
export const META_PIXEL_SERVICE_ID = 'J05PmJuvt36qTe';
export const META_PARTNER_NAME = 'facebook';
export const META_CAMPAIGN_SOURCE = 'meta';
export const ATTRIBUTION_LOOKBACK_SECONDS = 7 * 24 * 60 * 60;

type AttributionClick = {
  campaignSource?: string | null;
  clickId?: string | null;
};

export const hasContextualMeasurementOptOutCookie = (
  cookieString: string
): boolean =>
  cookieString.split(';').some((cookie) => {
    const [name] = cookie.trim().split('=');
    return name === CONTEXTUAL_MEASUREMENT_OPT_OUT_COOKIE;
  });

export const getEligibleMetaClickId = (
  clicks: AttributionClick[]
): string | undefined => {
  return clicks
    .find((click) => {
      return (
        click.campaignSource?.toLowerCase() === META_CAMPAIGN_SOURCE &&
        !!click.clickId?.trim()
      );
    })
    ?.clickId?.trim();
};
